<template>
    
    <div class="w-full h-auto mb-32 relative">

        <div class="z-0" style="background-image: url(https://genesis.zeus.vision/assets/valentina/img/header2.jpg); position: sticky; top:0;  background-repeat: no-repeat; background-size: cover; background-position: center; position: sticky; top:0; height:33vh;"></div>

        <div class="h-auto w-11/12 rounded-lg shadow-3xl mx-auto z-30 -mt-24 bg-white flex flex-col overflow-hidden relative"> 
                    
            <div class="h-auto flex flex-col overflow-hidden mb-2">

                <div class="h-auto w-full flex flex-row justify-center items-end pt-4">
                    <span class="text-gray-500 font-semibold text-3xl">Top Ventas</span>
                </div>

                <All model="products" :immediate="true" :query="query" v-slot="{data,loading}">

                    <div v-if="!loading" class="h-auto">

                        <div class="w-full h-auto flex flex-row justify-center items-center border-b border-gray-300">
                            <span class="text-3xl font-bold text-gray-700">{{data.data.total | reduceBigNumbers()}}</span>
                            <span class="text-xl text-gray-700">€</span>
                        </div>

                        <div class="h-auto">

                            <topSale v-for="(el,index) in data.data.products" :data="el" :key="index"></topSale>

                        </div>

                    </div>

                </All>

            </div>

        </div>

    </div>

</template>

<script>
import filters from './filters.vue';
import sale from './sale.vue';
import chartarea from './chartarea.vue';
import { state,actions } from '../store/store.js';
import topSale from './topSale.vue';
import { All } from '@/api/components';

export default {
    components:{
        filters,
        sale,
        chartarea,
        topSale,
        All
    },
    data(){
        return{
            
        }
    },
    methods:{
        
    },
    computed:{
        period(){
            return state.period
        },
        query(){
            if(state.period != 'custom' && !state.dates){

                return {
                    period: state.period,
                    store: state.store
                }

            } else {

                if(state.dates == null){

                    return{
                        period: state.period,
                        store: state.store
                    }

                } else {

                    return{
                        period: state.period,
                        store: state.period,
                        from: state.dates.start,
                        to: state.dates.end
                    }

                }

            }
        }
    },
    mounted(){
        
    }
}
</script>